import components from './components'
import data from './data'
import methods from './methods'
import mounted from './mounted'
import computed from './computed'

export default {
  data,
  components,
  methods,
  mounted,
  computed
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/resources/index.js